<template>
<div class="search">
    <input value="" placeholder="请输入书名/作者/主播" v-model="keyword" @click="getTips()" @keyup.enter="toSearch()"/>
    <button class="serachBtn" @click="toSearch()"></button>
    <div class="relative" v-if="showTips">
        <div class="show-tips">
            <div class="close" @click="getTips()">x</div>
            <h3>热门搜索 </h3>
            <div v-for="(item,index) in tips" :key="index">
                <span class="tips" @click="toSearch(item)">{{item}}</span>
            </div>
            <h3 class="history-title">搜索历史<span @click="clearHistory()">清空历史记录</span></h3>
            <div v-for="(item,i) in historyList" :key="i+'1'">
                <span class="history" @click="toSearch(item)">{{item}}</span>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            keyword: '',
            tips: [],
            historyList: [],
            showTips: false
        }
    },

    methods: {
        toSearch: function (e) {
            if (e) {
                this.getTips();
                this.keyword = e;
                this.$router.push({
                    path: '/search?keyword=' + e
                })
                return
            }
            if (this.keyword) {
                if (!this.historyList.includes(this.keyword)) {
                    this.historyList.unshift(this.keyword);
                    localStorage.setItem("historyList", JSON.stringify(this.historyList));
                } else {
                    //有搜索记录，删除之前的旧记录，将新搜索值重新push到数组首位
                    let i = this.historyList.indexOf(this.keyword);
                    this.historyList.splice(i, 1)
                    this.historyList.unshift(this.keyword);
                    localStorage.setItem("historyList", JSON.stringify(this.historyList));
                }

                this.$router.push({
                    path: '/search?keyword=' + this.keyword
                })
            }
        },
        getTips: function () { 
            this.showTips = !this.showTips
        },
        searchTips: function () {
            this.$http.post('/xcx/search-tips').then(res => {
                this.tips = res.data.data
            })
        },
        clearHistory:function(){
          localStorage.removeItem('historyList');
          this.historyList = []
        }
    },
    mounted() {
        if (JSON.parse(localStorage.getItem("historyList"))) {
            this.historyList = JSON.parse(localStorage.getItem("historyList"));
        }
        this.searchTips();
    }
}
</script>

<style scoped>
input,
button {
    outline: none;
}

h3 {
    width: 100%;
    clear: both;
}

.close {
    float: right;
    cursor: pointer;
    padding: 5px 10px;
}

.search {
    width: 200px;
    height: 30px;
    padding: 5px 0px;
    margin-top: 20px;
    background: rgba(241, 243, 243, 1);
    border-radius: 2px;
    float: left;
}

.search input {
    float: left;
    background: none;
    border: none;
    height: 30px;
    width: 130px;
    padding-left: 22px;
    font-size: 14;

    background-size: 50px 40px;
    background-repeat: no-repeat;
    background-position: left center;
}

.serachBtn {
    background-image: url(../assets/searchIcon.png);
    width: 30px;
    height: 30px;
    float: left;
    padding-left: 30px;
    background-size: 20px;
    background-repeat: no-repeat;
    background-position: right center;
    cursor: pointer;
}

button::after {
    border: none;
}

button {
    border: none;
    background: rgba(241, 243, 243, 1);
}

.relative {
    position: relative;
}

.show-tips {
    position: absolute;
    top: 50px;
    right: 0px;
    width: 300px;
    padding: 10px 20px;
    background: #FFFFFF;
    box-shadow: 0px 4px 16px 0px rgba(173, 195, 189, 0.43);
    border-radius: 2px;
    z-index: 9999;
    overflow-y: auto;
}

.tips {
    float: left;
    padding: 5px 20px;
    margin: 5px;
    color: #4BCCAA;
    background: #eefaf6;
    font-size: 16px;
    font-family: Source Han Serif CN;
    font-weight: 400;
    cursor: pointer;
}

.history {
    background: #F1F3F3;
    color: #869394;
    float: left;
    padding: 5px 20px;
    margin: 5px;
    font-size: 16px;
    font-family: Source Han Serif CN;
    font-weight: 400;
    cursor: pointer;
}

.tips:hover,
.history:hover {
    color: #ffffff;
    background: #4BCCAA;

}
.history-title{padding-top: 20px;}
.history-title span{font-size: 12px; color: #869394; font-weight: 400; float: right;}
</style>
